import { useState, useEffect } from "react";
import "./FooterMobile.css";
import { IoHomeOutline } from "react-icons/io5";
import { IoIosSearch, IoIosAdd } from "react-icons/io";
import { PiSquaresFour } from "react-icons/pi";
import { CiUser } from "react-icons/ci";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

const FooterMobile = () => {
  const [pageState, setPageState] = useState();
  const user = useSelector((state) => state.compteReducers.userConnected);
  const iconSize = 20;

  const [value, setValue] = useState("Accueil");
  const [hideFooter, setHideFooter] = useState(false);
  const [locationKeys, setLocationKeys] = useState([]);
  let history = useHistory();

  const handleChange = (event, newValue) => {
    event.preventDefault();
    setValue(newValue);
    if (newValue === "Accueil") {
      history.push("/");
    } else if (newValue === "DetailsUser") {
      if (user) {
        history.push({
          pathname: `/details-user/${user.pseudo}`,
          id: user.id,
        });
      } else {
        history.push("/login");
      }
    } else if (newValue === "Ajout") {
      user ? history.push("/new-publication") : history.push("/login");
    } else if (newValue === "Menu") {
      user ? history.push("/MonCompte") : history.push("/login");
    } else if (newValue === "Recherche") {
      history.push("/searchPageMobile");
    }
  };

  useEffect(() => {
    const pathname = history.location?.pathname;
    const labelMap = new Map();
    labelMap.set("/", "home");
    labelMap.set("/searchPageMobile", "search");
    labelMap.set("/MonCompte", "menu");
    labelMap.set("/login", "profile");

    setPageState(labelMap.get(pathname) ? labelMap.get(pathname) : "");

    const hideFooter2 =
      history.location.pathname.includes("registration") ||
      history.location.pathname.includes("publication-app") ||
      history.location.pathname.includes("details-message");
    setHideFooter(hideFooter2);

    return history.listen((location) => {
      const hideFooter2 =
        history.location.pathname.includes("registration") ||
        history.location.pathname.includes("publication-app") ||
        history.location.pathname.includes("details-message");
      setHideFooter(hideFooter2);

      if (history.action === "PUSH") {
        setLocationKeys([location.key]);
      }

      if (history.action === "POP") {
        if (locationKeys[1] === location.key) {
          setLocationKeys(([_, ...keys]) => keys);
          // Handle forward event
        } else {
          // GO BACK
          setLocationKeys((keys) => [location.key, ...keys]);
          // Handle back event
        }
      }
    });
  }, [locationKeys, history]);

  return (
    <>
      {!hideFooter && (
        <div className="d-block d-md-none mbr_footer_mobile position-fixed w-100 d-flex">
          <FooterIcons
            pageState={pageState}
            label={"home"}
            onClick={(e) => handleChange(e, "Accueil")}
          >
            <IoHomeOutline size={iconSize} />
            <p className="text-gray-icon k-semibold-12 p-0 m-0">Home</p>
          </FooterIcons>
          <FooterIcons
            pageState={pageState}
            label={"menu"}
            onClick={(e) => handleChange(e, "Menu")}
          >
            <PiSquaresFour size={iconSize} />
            <p className="text-gray-icon k-semibold-12 p-0 m-0">Menu</p>
          </FooterIcons>
          <div
            className="position-relative"
            onClick={(e) => handleChange(e, "Ajout")}
          >
            <div
              className="coeur"
              style={{
                background: "#FFE05C",
                borderRadius: "100%",
                width: 50,
                height: 50,
                border: "white 5px solid",
              }}
            >
              <IoIosAdd color="gray" size={iconSize + 15} />
            </div>
          </div>
          <FooterIcons
            pageState={pageState}
            label={"search"}
            onClick={(e) => handleChange(e, "Recherche")}
          >
            <IoIosSearch size={iconSize} />
            <p className="text-gray-icon k-semibold-12 p-0 m-0">Search</p>
          </FooterIcons>
          <FooterIcons
            pageState={pageState}
            label={"profile"}
            onClick={(e) => handleChange(e, "DetailsUser")}
          >
            {user ? (
              <img
                src={user.profil}
                className="rounded-pill rounded_26"
                alt=""
              />
            ) : (
              <>
                <CiUser size={iconSize} />
                <p className="text-gray-icon k-semibold-12 p-0 m-0">Sign in</p>
              </>
            )}
          </FooterIcons>
        </div>
      )}
    </>
  );
};

const FooterIcons = ({ pageState, label, children, ...props }) => {
  return (
    <div
      className={`${pageState === label ? "mbr_footer_mobile_section_active" : "mbr_footer_mobile_section"} mbr_footer_mobile_icon d-flex flex-column align-items-center`}
      {...props}
    >
      {children}
    </div>
  );
};

export default FooterMobile;
